import { Button } from '@fluentui/react-components'
import { Add16Regular } from '@fluentui/react-icons'
import { useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { createRestClient } from '@/contexts/QueryProvider'
import { DirectLinkedUserCard } from '../FluentCard/DirectLinkedUserCard'
import { OverlayDrawerComponent } from '../OverlayDrawerComponent/OverlayDrawerComponent'
import { AddUserToWorkspaceForm } from '../SubscriptionControl/AddUsersToWorkspaceForm'
import './DirectLinkedUsersPanel.scss'

type DirectLinkedUsersPanelProps = {
  workspaceId: number
  projectId: number
  appId: number
  orgId: number
}

export function DirectLinkedUsersPanel({ projectId, appId, orgId, workspaceId }: DirectLinkedUsersPanelProps) {
  const { getWorkspacesApiGetUsers } = createRestClient()

  const {
    data: projectUsers,
    // isPending: usersPending,
    // isError: usersError,
  } = getWorkspacesApiGetUsers.useQuery({
    query: { workspaceId },
  })

  const [addDrawerOpen, setAddDrawerOpen] = useState(false)

  return (
    <div>
      <div className="flex items-center justify-between border-b pb-1">
        <div>
          <h5>Direct linked users</h5>
          <p>Add or remove users from the workspace and manage their roles.</p>
        </div>
        <Button
          appearance="primary"
          icon={<Add16Regular />}
          onClick={() => {
            setAddDrawerOpen(true)
          }}
        >
          Add user
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-4 py-3 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
        {projectUsers?.map((user) => (
          <DirectLinkedUserCard
            key={user.id}
            user={user}
            editEnabled={true}
            projectId={projectId}
            orgId={orgId}
            appId={appId}
            workspaceId={workspaceId}
          />
        ))}
      </div>

      {/* Add User Drawer */}
      <OverlayDrawerComponent
        open={addDrawerOpen}
        setOpen={setAddDrawerOpen}
        title="Add User to Workspace"
        size="medium"
        content={
          <AddUserToWorkspaceForm
            onSubmit={() => setAddDrawerOpen(false)}
            projectId={projectId}
            workspaceId={workspaceId}
            orgId={orgId}
            appId={appId}
          />
        }
      />
    </div>
  )
}
